module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('figure', {
    staticClass: "img90"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0012-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "veg"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0013-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('p', {
    staticClass: "recmnb",
    attrs: {
      "id": "recmn1"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("JANUARY")])]), _vm._v(" "), _c('figure', {
    staticClass: "img70b"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0014-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p15"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0015-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("SWEET POTATO & SPINACH GRATIN")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("This dish pairs nicely with the meatballs from "), _c('span', {
    attrs: {
      "href": "#/xhtml/fish#p91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("this page")]), _vm._v(", but it works just as well as a stand-alone dish, served with a good salad. Serve in soup bowls as single portions and it will immediately look like a serious dinner. As if you really made an effort. Since most of us are eating a little less meat these days, I will give you even more inspiration for vegetable dishes in this book. So off we go, and remember: Anything made in the oven with cream and cheese will be a surefire hit with almost everyone. Even my hubby, Oof, normally not a fan of sweet potatoes, gobbled up two portions. Who’s next?")]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 cup plus 1 tablespoon (250 ml) heavy cream")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 clove garlic, peeled and crushed")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 sprigs fresh thyme")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("14 ounces (400 g) spinach")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Freshly grated nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 pound 14 ounces (850 g) sweet potatoes, peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Butter for the baking dish")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Generous 1 cup (250 g) ricotta")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Scant ⅔ cup (60 g) grated aged cheese, such as Parmesan")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In a saucepan, bring the cream, garlic, and thyme sprigs to just under a boil and let steep at that temperature for 10 minutes. Remove and discard the garlic and thyme.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In a wok, heat the oil and briefly stir-fry the spinach. Season with salt, pepper, and nutmeg. Press the spinach in a strainer to remove excess liquid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Very thinly slice the sweet potatoes with a mandolin or a food processor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Butter a baking dish and spread one-quarter of the potato slices in the bottom. Spread some of the ricotta on top and season with salt and pepper. Place a second layer of potatoes on top, then ricotta, pepper, salt, and spinach, and continue layering until everything has been used. Douse with the cream. Sprinkle with the grated cheese and bake for 45 minutes, or until everything is nicely done.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page16"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0016-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p17"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0017-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("BUTTERNUT SQUASH RISOTTO WITH SAGE")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("Perhaps you’re like me and you have had it with the culinary fuss. This is simple food that can be eaten with just a spoon and in which you can use those vegetables from the produce drawer of your fridge as well as those holiday cheese leftovers. There is no dish more comforting than a bowl of risotto. And because this one comes out of the oven, it requires only a little work. After just 10 minutes of tinkering in the kitchen you can go straight back to the couch you came from. If only every day could be this cozy.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ butternut squash, peeled and cut into ⅜-inch (1 cm) cubes")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ rutabaga or another root vegetable, peeled and cut into ⅜-inch (1 cm) cubes")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Splash of olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Knob of butter (about 1 tablespoon)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 shallots, minced")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1½ cups (300 g) arborio rice")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 small bunch fresh sage, cut into slivers")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 cloves garlic, pressed")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("¾ cup (75 g) grated Parmesan or another cheese (for on top)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("¾ cup plus 1 tablespoon (200 ml) dry white wine")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("4½ cups (1 L) hot vegetable broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Spread the vegetable cubes out on a baking sheet and sprinkle with a splash of oil and some salt and black pepper. Roast for 30 minutes, until they start to brown. For the last 10 minutes, place a baking dish in the oven as well so it can preheat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Meanwhile, melt the butter in a nonstick skillet. Add the shallots and stir-fry for 6 minutes, until soft. Stir in the rice, sage, and garlic, stirring every other minute or so.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Spoon in the roasted vegetables and three-quarters of the cheese and douse with the wine. Stir everything loose until it’s thoroughly mixed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Reduce the oven temperature to 350°F (180°C) and spoon the vegetable mixture into the warm baking dish. Pour in the hot broth and stir well once more. Bake uncovered for 40 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve right away with the rest of the cheese sprinkled on top.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page18"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0018-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p19"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0019-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("VEGETARIAN ENCHILADAS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("Let’s make a fresh and clean start in January. I was thinking: vegetarian and comforting. When it comes to flavor, corn tortillas are my wholehearted preference over flour. When I discovered that my neighborhood supermarket sold them in their gluten-free section, I immediately stocked up on them. Not only do they taste better than flour tortillas, but they’re also a bit lighter, just as sweet potatoes are somewhat lighter than regular potatoes. Starting the year off nice and light, using only vegetables: it just feels like a good idea to use tortillas made from vegetables too.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingresb"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOR THE SAUCE")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 (14.5-ounce/411 g) cans diced tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 tablespoon ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 teaspoons dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 teaspoon smoked paprika")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("¼ teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Sea salt and freshly ground black pepper to taste")]), _vm._v(" "), _c('p', {
    staticClass: "ingresb"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND ALSO")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 tablespoon olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 cloves garlic, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 to 2 tablespoons finely chopped jalapeños")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 sweet potatoes, peeled and finely diced")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("7 ounces (200 g) spinach")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 (15.5-ounce/439 g) can black beans, rinsed and drained")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Squeeze of lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("12 small (or 6 large) corn tortillas, briefly heated")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("1 cup (100 g) shredded cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingresb"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TO GARNISH")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Fresh cilantro, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Avocado chunks")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Make the sauce: Combine all the ingredients in a pitcher.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In a large saucepan, sauté the onion in the oil until tender, add the garlic, and cook for another minute.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Stir in the jalapeños and sweet potatoes and cook, covered, for 12 to 15 minutes, until done, stirring occasionally. Spoon in half of the sauce, the spinach, and the beans. Let simmer and reduce to a “non-wet” filling. Season with lime juice.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Fill each tortilla with a scoop of filling and roll up. Pack the rolls side by side in a greased baking dish.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Pour the remaining sauce on top and sprinkle with the cheese. Bake for about 20 minutes, until the cheese is golden brown and the sauce bubbling.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Garnish with cilantro and avocado chunks. Serve with some sour cream.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page20"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0020-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p21"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0021-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("ROOT VEGETABLE TARTLETS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("Recently I was looking for a side dish to substitute for potatoes because I had run out of those. What I did find in my produce drawer were half a celeriac and a lonely sweet potato. I didn’t expect to actually feed six people with this meager amount, but in fact it was easy. And what’s more, I thought my root concoction looked pretty restaurant-ish.")])]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_vm._v("This is a recipe to keep handy, pinned to your fridge, because you could make this using any root vegetable and cheese you have lying around. You’ll always have a nice side dish on hand. Serve these tartlets with a large bowl of salad and a roasted chicken or fish and you’ll be sitting down to a fantastic dinner just like that.")]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 6 as a side dish")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ celeriac, cleaned (about 12 ounces/350 g)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 sweet potato (8¾ ounces/250 g), also cleaned")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Juice of ½ lemon")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Handful of sage leaves, chopped (or oregano or rosemary)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ cup (50 g) grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Splash of olive oil for the pan")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Grate the celeriac and sweet potato on the coarse holes of a box grater or in a food processor with the coarse grater plate. Mix with the lemon juice right away to prevent discoloration.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Using clean hands, mix in the sage, eggs, and cheese until evenly combined. Season with a pinch of salt and a generous amount of pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Thoroughly grease a muffin pan with twelve cups and divide the vegetable mixture among the cups. Press carefully until the surface is nicely even. Bake the tartlets for 35 to 40 minutes, until nicely golden brown and done.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Still in doubt about the doneness? You should be able to pierce them with a sharp knife. If you feel any resistance that means they need to stay in the oven for a little longer. Done baking? Turn them out of the muffin pan and serve as a side dish right away.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page22"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0022-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p23"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0023-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("FILLED BABY PUMPKIN")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("In December I was doing book signings in bookstores throughout the Netherlands. It was close to Christmas and people were lining up in remarkably long lines in order to personalize their cookbook gifts with my signature. I’m not telling you this to brag about myself, but rather about Ceder, a boy who was standing in line with his mother and his big brother. He had already sent me a postcard once and now he had traveled for an hour and stood in line for another hour just to shake my hand. Once it was his turn, he handed me a beautiful baby pumpkin. He was nervous, so he didn't say much, but such a cheerful, round pumpkin says more than a thousand words. I promised him that I’d use it to cook something delicious and animal-free, because he doesn’t eat animals. Voilà, Ceder, see you soon.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("for 1 boy")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 small organic pumpkin (about 1 pound 9 ounces/700 g)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 tablespoons olive oil, plus extra")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("10½ ounces (300 g) spinach")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("⅓ cup (75 ml) mascarpone cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ cup (50 g) crumbled goat (or other) cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Generous ⅓ cup (30 g) panko or regular breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Pinch of red pepper flakes")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Cut off the pumpkin’s cap. Remove the seeds and pulp using a knife and a tablespoon. Sprinkle with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Slightly sauté the onion in the oil until tender, then add the spinach as well. Let cool in a bowl. Now add the rest of the ingredients and stir until the filling is evenly combined. Use it to stuff the pumpkin.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Oil the outside of the pumpkin, as well as a baking dish. Place the pumpkin and its cap side by side in the dish, cover with aluminum foil, and bake for 45 minutes. Remove the foil and bake for 15 minutes more. You can eat it whole.")]), _vm._v(" "), _c('p', {
    staticClass: "recmnb",
    attrs: {
      "id": "recmn2"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("FEBRUARY")])]), _vm._v(" "), _c('figure', {
    staticClass: "img70b",
    attrs: {
      "id": "page24"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0024-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p25"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0025-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("GNOCCHI ALLA ROMANA")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("Semolina can be used for more than making traditional Dutch "), _c('em', [_vm._v("griesmeel")]), _vm._v(" pudding. In Rome they also know their way with it. The Romans use it for a savory dish that I would love to share with you here. The texture of "), _c('em', [_vm._v("gnocchi alla romana")]), _vm._v(" is very similar to that of polenta. But since we are using semolina, made from durum (a hard wheat variety), instead of cornmeal, it’s a bit different—lighter. We ate this dish with a thick, spicy tomato sauce and a bowl of salad. Delicious comfort food for a cold day. And afterward you can eat one of those little puddings for dessert, you know, with some cranberry sauce poured on top.")]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 6 as a side dish")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4½ cups (1 L) whole milk")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("5 tablespoons plus 1 teaspoon (75 g) butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1⅓ cups (250 g) semolina")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 cup (100 g) finely grated Parmesan cheese, plus extra")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 egg yolks")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Splash of olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In a large saucepan, bring the milk, butter, and a pinch of salt to a boil and turn the heat to medium-high. Whisk in the semolina and cook for 1 to 2 minutes, until it has thickened and is fiercely bubbling. Remove from the heat and stir in the cheese and egg yolks. Season with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Pour the thick batter in two portions onto two large sheets of parchment paper and use these papers to swiftly shape it into two thick rolls. (Or pour onto a parchment paper–lined baking sheet and smooth the surface using the back of a wet spoon.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Let cool completely. Once it has reached room temperature, put in the refrigerator. Let firm up for at least 2 hours; you could do this a day in advance.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Using a wet knife, cut the roll into ½-inch (12 mm) slices, or use a round cutter to cut discs from the dough sheet. Oil a baking dish and shingle the slices in the dish. Sprinkle with extra cheese and some oil. Bake for 25 to 30 minutes, until golden brown and piping hot.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page26"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0026-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p27"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0027-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("LEFTOVER FOCACCIA")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("We recently ate Dutch potato-vegetable mash on a day when the weather was gloomy—I was actually looking for an excuse to eat smoked sausage, so I chose a dish to go with it. We had just a bit left; not quite enough for the day after, and it would be a shame to simply throw it out. Suddenly I remembered my own old recipe for potato focaccia made with mashed potatoes; potatoes are the bomb when used in bread. They make it soft and spongy, and it becomes a comforting kind of bread that you’d want to eat every day. I hoped it would pair well with the mash. The result was surprisingly good. Hurray, we repurposed another leftover dish and we ate a delicious bread that night. A perfect solution.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2¼ teaspoons (one 7 g envelope) instant yeast")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 cup plus 1 tablespoon (250 ml) lukewarm milk")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("8¾ ounces (250 g) potato-vegetable mash, or mashed potatoes, at room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("⅔ cup (1 stick plus 3 tablespoons/150 g) butter, at room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4¾ cups plus 2 tablespoons (625 g) all-purpose flour, plus extra")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 to 3 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Sea salt flakes")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Dissolve the yeast in 3 tablespoons of the milk.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Combine the mash, butter, eggs, and salt until smooth. Add the yeast mixture and the rest of the milk. Mix well. Stir in the flour. Knead for at least another 5 minutes with flour-dusted hands. Shape into a nice supple ball and set the dough in a warm spot for at least 1 hour to rise.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Knead the dough for another 3 minutes on a flour-dusted countertop, and press the dough into a large, oval, flat loaf of about 8 by 12 inches (20 by 30 cm).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Line a baking sheet with parchment paper and dust with flour. Set the dough on the parchment. Brush lightly with oil and sprinkle with some salt flakes. Cover with a clean dish towel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Let the bread rise for another 30 minutes, then bake for 25 to 30 minutes, until golden brown.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page28"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0028-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p29"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0029-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("QUINOA & BROCCOLI FROM THE OVEN")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("I recently read in the Dutch newspaper "), _c('em', [_vm._v("De Volkskrant")]), _vm._v(" that the consumption of quinoa in the Netherlands is on the rise. This surprised me, really. I thought the hype was long over. I like quinoa very much; it’s a bit nutty, and crispy in a salad or as a side dish. However, I actually had stopped buying it after I heard stories about the Peruvian people (the plant is native to the Andes mountains) who are no longer able to afford it due to our huge consumption. But from that Dutch article I learned that quinoa is now being grown by Dutch farmers (organically) and that the price for the Peruvians has leveled—a relief. That evening I immediately made a dish with Dutch quinoa. It’s nutritious, rich in fibers, minerals, and proteins, and gluten free, in case that’s important to you. It’s an ideal substitute for potatoes or rice, only much lighter.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("¾ cup plus 2 tablespoons (150 g) quinoa (any color)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Scant 2 cups (450 ml) vegetable stock or water")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 pound 7 ounces (650 g) broccoli florets (2 heads)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 tablespoons (60 ml) olive oil, plus extra for greasing the baking dish")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Pinch of red pepper flakes")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 clove garlic, pressed")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1½ cups (150 g) shredded cheese, such as Cheddar or Gouda")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("About 1 cup plus 1 tablespoon (250 ml) vegetable stock or milk")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Handful of shelled walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Cook the quinoa for 20 minutes in the scant 2 cups (450 ml) stock or water until all the liquid has been absorbed. Remove from heat and let evaporate for 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Combine the broccoli with 2 tablespoons of the oil, and salt and pepper to taste, and arrange on a baking sheet lined with parchment paper. Roast for 20 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Toast the walnuts in a dry skillet until crunchy. Break them into pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Lower the oven temperature to 350°F (180°C). Mix the cooked quinoa with salt, pepper, red pepper flakes, garlic, two-thirds of the cheese, and the 1 cup plus 1 tablespoon (250 ml) stock or milk until thoroughly combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fold in the broccoli florets until they’re entirely coated. Scoop this into a greased baking dish and sprinkle with the remaining cheese and the walnuts. Bake the dish for 25 minutes.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page30"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0030-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p31"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0031-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("ROASTED CELERY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("After a couple of extravagant days in Paris and Antwerp, it was really time for reflection in Van Boven’s kitchen. All this feasting really needed to be over. From now on, simplicity is the mantra. Well that’s easier said than done; I have to constantly test recipes and then, what to do with all that food? Best to eat it, but doing that you turn fat. Sharing is the solution. Bringing people together for a simple dinner—that’s fun.")])]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_vm._v("Slow-roasted celery is such a simple thing, so bare-bones but at the same time such an amazing dish. It’s exciting and full of flavors that compete for attention. It’s as if you’re eating three courses at the same time, but in one simple dish. Oh, simplicity is such fun.")]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 bunches celery, halved lengthwise, leaves coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 to 4 cloves garlic, pressed")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 tablespoons apple cider")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("6 tablespoons (90 ml) hazelnut oil or good olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 bunch fresh parsley, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("¾ cup plus 1 tablespoon (200 ml) vegetable stock, acidified with 2 to 3 tablespoons apple cider")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Heaping 1 cup (150 g) crumbled blue (Stilton) cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("⅔ cup (70 g) coarsely chopped hazelnuts")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Bring a large pot of salted water to a boil. Blanch the celery for 3 minutes, scoop them out with a slotted spoon, and let drain. Place the celery on a baking sheet, cut sides down.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Whisk the garlic with the cider and oil and season with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Sprinkle the celery with half of the dressing and half of the parsley and slide the baking sheet into the oven. Pour the stock over them and cook for 45 to 60 minutes (depending on the thickness of the celery), until it’s al dente and the tips are coloring.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Transfer to a serving platter if desired. Drizzle with the rest of the dressing; sprinkle with the rest of the parsley, the celery leaves, cheese, and hazelnuts; and serve.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page32"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0032-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p33"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0033-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("CABBAGE ROLLS WITH CARAWAY & HAZELNUT")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("Well, I’ve ordered seeds and my new vegetable garden is almost finished. It was quite a bit of work, because we built raised beds from scratch. Soon I’ll be growing the most diverse vegetables, ones that I never see at the farmers’ market in the Netherlands (otherwise I’d buy them). There will be red broad beans, long white string beans, and black radishes in my vegetable beds.")])]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_vm._v("But first we’ll finish enjoying the last of the winter vegetables. You may be quite done with cabbage, but prepared this way, it becomes tempting again.")]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Splash of olive oil, plus extra")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 onion, diced")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 big clove garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Generous ½ cup (100 g) brown rice")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ cup (100 g) green lentils, ideally Du Puy")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 cups plus 2 tablespoons (500 ml) vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("8 to 12 leaves Savoy cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 bunch fresh parsley, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("⅔ cup (100 g) crumbled feta cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Generous ⅓ cup (50 g) hazelnuts, toasted and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 teaspoons caraway seeds")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Heat a splash of oil in a pan with a lid. Sauté the onion with the garlic until tender. Add the rice and lentils. Douse with 1⅔ cups (400 ml) of the stock and bring to a boil. Lower the heat, place the lid on the pan, and let simmer gently for 25 minutes, or until the lentils are al dente. Let everything cool off for a bit.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Blanch the cabbage leaves in salted water, rinse well, and remove the tough stems.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Stir the parsley, cheese, hazelnuts, and caraway into the rice mixture and taste for salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 350°F (180°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Place a cabbage leave in front of you and add a generous scoop of the rice filling in the middle, just above where you cut out the stem. Fold the sides inward and roll up the leaf from the unfolded edge to create a small package. Secure with a toothpick and place seam side down in a baking dish. Repeat with the remaining cabbage and filling. Pour the remaining stock over the rolls and cover with aluminum foil.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bake for 15 minutes. Drizzle some oil over the dish and serve with a side of vegetable puree.")]), _vm._v(" "), _c('p', {
    staticClass: "recmnb",
    attrs: {
      "id": "recmn3"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("MARCH")])]), _vm._v(" "), _c('figure', {
    staticClass: "img70b",
    attrs: {
      "id": "page34"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0034-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p35"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0035-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("CUPBOARD CANNELLONI")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("For a minute, it looked like spring had arrived, but then temperatures dropped steeply, and it started pouring again. I longed for summer and didn’t feel like getting soaked while biking to the store. So I investigated my cupboard instead. It’s my favorite thing to do anyway; making "), _c('em', [_vm._v("something")]), _vm._v(" out of seemingly "), _c('em', [_vm._v("nothing")]), _vm._v(". I checked my freezer: two fennel sausages. And my fridge: half a bag of spinach and a cheese rind. Together with some finds from my cupboard, these ingredients turned into a fantastic dish. Just like that. On my plate, the sun was shining and I’d managed to stay bone dry.")]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("12 sheets lasagna")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 onions, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 cloves garlic, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Splash of olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 links fennel sausage (about 8¾ ounces/240 g), casings removed")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("8¾ ounces (250 g) spinach (frozen is fine)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Pinch of red pepper flakes")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 tablespoons tomato paste")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ glass red wine")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 (14.5-ounce/411 g) can diced tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Chunk of cheese for grating (any type that melts will do)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 350°F (180°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Slide the lasagna sheets into a pot of boiling water three at a time and cook for 1 minute. Remove the sheets when they’re just about soft. Separate and let them dry spread out on a clean dish towel. Reserve the cooking liquid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Sauté half of the onions and two-thirds of the garlic in some oil and add the sausage meat in pieces. Fry until the meat is cooked through, then spoon in a ladleful of pasta cooking liquid. Add the spinach and cook until the liquid is reduced. Season with red pepper flakes and some salt if needed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In a saucepan, sauté the remaining onion and garlic in oil until tender. Add the tomato paste and fry. Douse with the wine and tomatoes. Reduce the sauce somewhat and season with red pepper flakes and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put 1 tablespoon of the sausage-spinach filling on a short end of a lasagna sheet and roll it up. Place in an oiled baking dish. Repeat until everything is used. Pour the sauce on top and sprinkle with the cheese. Bake the cannelloni for 25 minutes.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page36"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0036-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p37"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0037-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("BEET ROSE")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_vm._v("I made this dish for my dearest on Valentine’s Day. It was more or less by accident, to be honest, which I didn’t mention because he was genuinely moved. By now this day is behind us, but without a doubt your sweetheart will have a birthday coming up this year, or maybe you have to make up for something. If so, instead of buying flowers, you could bake a beet rose. At first glance, it kind of resembles carpaccio, but it’s more exciting. Because the beets are cooked in butter and red vermouth, they retain that sweetness. As well as their bite, which is remarkable after baking them for such a long time. It does make the dish tastier, however. I served it with a spinach and blue cheese soufflé.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 pound 2 ounces (500 g) trimmed red beets")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("5 tablespoons (70 g) butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 to 3 shallots, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 cloves garlic, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 teaspoons fresh thyme")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ cup (125 ml) red vermouth")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Thoroughly rinse the beets, then peel them. Shave with a mandolin into paper-thin slices (about 1.5 mm thick).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Melt the butter in a saucepan and add the shallots, garlic, and thyme. Let the shallots soften over low heat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Dip a brush into the warm butter and grease a shallow baking dish. (You can also use a cast-iron skillet.) Shingle the beet slices in circles in the dish so they resemble a rose.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Douse the butter in the saucepan with the vermouth, bring to a boil, and add salt and pepper to taste. Pour over the beet slices, covering everything with a thin layer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Carefully cover the dish with aluminum foil and bake for 45 minutes. Remove the foil and bake for another 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "recmnb",
    attrs: {
      "id": "recmn4"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_vm._v("APRIL")])]), _vm._v(" "), _c('figure', {
    staticClass: "img70b",
    attrs: {
      "id": "page38"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0038-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p39"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0039-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("ROASTED BEET SALAD WITH FRESH SPRING HERBS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("Of course, I don’t know what the situation on your windowsill is right now, but my herb garden is in full festive mood; the chives are about to bug out and the chervil is germinating. Now that I have my own garden, I’m witnessing everything up close. Every hour something wondrous is taking place. I used to be amazed by the wisdom of my friends the two old brothers Georges and Charles, who grew up on a farm in the south of France. They live off the harvest from their garden. They can tell about how the air changes from hour to hour and how this affects their beans, artichokes, or pears. I find these stories fascinating. And now I notice that I’m developing that same awareness. It’s addictive. I better watch out, or I’ll turn into a farmer in no time. As soon as something comes up in my herb boxes I swoop in; I trim and toss them in my pan to make a colorful roasted vegetable salad, using every windowsill herb I can find.")]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 Chioggia beets, trimmed")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 red onions, unpeeled")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 cloves garlic, unpeeled")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Splash of olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("A good handful of fresh garden herbs")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("About 5½ cups (200 g) watercress")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("3½ ounces (100 g) feta cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingresb"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOR THE DRESSING")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 tablespoon tahini")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 teaspoon Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Juice of ½ lemon")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("6 tablespoons (90 ml) sunflower oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 350°F (180°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Place the beets, onions, and garlic cloves in a baking pan. Drizzle with some oil, sprinkle with salt and pepper, and cover with aluminum foil.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Bake for about 1½ hours, until the beets are al dente, removing the onions and garlic after 1 hour because they’re done sooner. Peel everything and cut into wedges.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Make the dressing: Press the garlic into a bowl for the dressing. Whisk in the rest of the ingredients. If it gets too thick, add a few drops of water.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Toss the roasted vegetables with the dressing and then toss with the chopped herbs and watercress. Crumble the feta on top.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page40"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0040-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p41"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0041-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("SMOKY BUTTERNUT SQUASH & PAPAYA SALAD")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }, [_vm._v("Leafing through the Mexican cookbook "), _c('em', [_vm._v("Hartwood: Bright, Wild Flavors from the Edge of the Yucatán")]), _vm._v(", I stumbled upon a papaya salad. I’m not much of a papaya fan. Cut in half it looks like an alien has laid eggs inside it, and its flavor is that of bland melon. I mean, just use real melon—it’s way more assertive. In the recipe, Chef Eric Werner recommended combining papaya with grapefruit. Because I truly believe in his cooking skills, I decided to make his recipe. I was astonished; that combination gave my salad an earthy perfume that knocked me off my feet. So simple and to the point. From now on I’ll know better than to avoid ingredients I don’t like; there’s always a chance I’ll be pleasantly surprised. Cooking is fun, no? Here you’ll find my variation on his salad.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4 to 6")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 butternut squash (900 g)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1½ tablespoons smoked paprika")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ cup (120 ml) olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 pound 5 ounces (600 g) papaya, peeled and seeded")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 pink grapefruit, halved")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Honey")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 cups (400 g) green lentils, preferably Du Puy, cooked")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 fennel bulb, very thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Juice from about 1 lime")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Generous ¼ cup (15 g) chopped fresh flat-leaf parsley")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Cut the squash in half and scrape out the seeds with a spoon. Then cut into slices ⅜ inch (1 cm) thick. Toss these half moons with the paprika, salt and pepper to taste, and ¼ cup (60 ml) of the oil. Spread the squash on a baking sheet and roast for 35 minutes, or until tender.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Puree about half of the papaya together with the juice of ½ grapefruit and a drop of honey. Season with salt and pepper. In a large bowl, combine the lentils with the fennel, lime juice, and the remaining ¼ cup (60 ml) oil. Let stand. Cut the rest of the papaya into cubes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Separate the grapefruit segments from the membranes with a knife. Do this over the bowl with the lentils so the dripping juice will be mixed in as well. Loosely combine everything: the warm butternut squash, the fruit, lentil mixture, and parsley.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now spread the pureed papaya onto a large plate. Spoon the salad on top. (You could crumble some feta over it this as well.) Serve immediately.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page42"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "title": "42"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0042-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p43"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0043-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("GOAT CHEESE PASTRY POCKETS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "title": "43"
    }
  }, [_vm._v("Outside on the sunny terrace of my neighborhood lunch spot Jaurès in Paris, the half–North African, half-French staff is serving a "), _c('em', [_vm._v("chèvre chaud")]), _vm._v(" salad with crispy envelopes of goat cheese folded inside pastry. For a regular "), _c('em', [_vm._v("chèvre chaud")]), _vm._v(", the goat cheese is gratinated on baguette slices, but wrapped in brick dough. It really is pretty delicious. Brick is commonly used for wrapping bites in the Tunisian cuisine. The sheets resemble spring roll pastry or filo dough—and you could use these as well—but they’re not quite the same. Brick dough is made from ground cooked semolina; filo dough is made from regular wheat flour. Indonesian wheat spring roll sheets are also made from wheat flour, but these usually have egg white or coconut oil added, rendering them less crispy than filo dough and making them better alternatives for brick pastry. Remember, as with all pastry sheets, carefully cover the ones you’re not working with to keep them from drying out. Try different doughs out and decide for yourself which type you prefer.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("7 ounces (200 g) soft goat cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 to 5 goat-cheese-stuffed Peppadew peppers in oil, finely chopped, or 5 jarred piquillo peppers plus 1 ounce goat cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 tablespoons finely chopped fresh flat-leaf parsley")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 teaspoons spicy mustard")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 tablespoons whiskey or dry sherry")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("5 tablespoons plus 1 teaspoon (75 g) butter, melted")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("6 sheets filo dough or brick dough, cut in half")]), _vm._v(" "), _c('p', {
    staticClass: "ingresb"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOR THE SALAD")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 tablespoons red wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 to 5 tablespoons (60 to 75 ml) sunflower oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 teaspoon spicy mustard")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 clove garlic, finely grated")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 head red oak leaf lettuce")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("2 to 3 tomatoes, cut into wedges")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Crumble the goat cheese, combine in a bowl with the Peppadews and parsley, and fold in the mustard and whiskey. Generously season with black pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Brush a strip of dough with the melted butter. Scoop a rounded tablespoonful of the goat cheese mixture onto one end. Fold the opposite edge over, then fold the dough over diagonally. Continue folding over the dough until you have a neatly sealed triangle. Place on a parchment paper–lined baking sheet and repeat with the remaining dough and filling. Bake for 20 minutes, or until nicely crunchy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Make the salad: Whisk the vinegar, oil, mustard, and garlic together. Toss with the lettuce. Divide the salad among four plates and arrange the tomato wedges on top (and perhaps add some pieces of crisp bacon, nuts, and thin shallot rings—always lovely.) Place three brick bites on each salad and serve.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page44"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44",
      "title": "44"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0044-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p45"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0045-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page45"
    }
  }, [_vm._v("WHOLE-WHEAT PIZZA WITH GARDENER’S WOE")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45",
      "title": "45"
    }
  }, [_vm._v("While the rest of the world was foraging for their wild garlic pesto and nettle soup, I was pulling weeds in my garden. Back in the day, my sister and I would earn some pocket money by removing ground elder, also commonly called “gardener’s woe.” Ground elder is a persistent plant that is almost impossible to get rid of; each chopped-off piece of root continues to grow. But don’t worry; this weed is edible. Prepare ground elder like you would spinach, or dry bunches of it upside down in your pantry and crumble a leaf over a soup; it tastes like parsley. Just like that, you turn a problem into a pearl. And after an afternoon of pulling weeds, a weed pizza is very welcome. Trust me.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingresb"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOR THE PIZZA DOUGH")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2⅓ cups (300 g) whole-wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1½ teaspoons instant yeast")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 tablespoon olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ cup (50 g) grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Pinch of sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Scant ⅔ cup (160 ml) lukewarm water")]), _vm._v(" "), _c('p', {
    staticClass: "ingresb"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ON TOP")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("A good handful of ground elder or spinach (say, 6¼ ounces/175 g)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Splash of olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 shallot, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 cloves garlic, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Pinch of red pepper flakes")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Pinch of semolina (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("(Homemade!) tomato sauce")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Several types of cheese, of your own preference")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Make the pizza dough: Combine all the ingredients and knead for 10 minutes. Allow to rise in a warm spot for 1 hour. (This is a good time to pick the ground elder.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to as hot as possible, preferably to 500°F (250°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Wash the ground elder, remove the stems, and shake dry somewhat. Heat some oil in a large skillet. Sauté the shallot and add the garlic. Chop the ground elder leaves and stir into the shallot and garlic. Continue cooking until tender, and season with salt and red pepper flakes. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Roll out the dough into a thin round and place on an oiled (and semolina-dusted, if possible) baking sheet. Top with tomato sauce, the sautéed ground elder, and a sprinkle of a cheese of your choice. Sprinkle with oil and bake in the scorching-hot oven for 10 minutes, or until done.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Never before have weeds tasted this great.")]), _vm._v(" "), _c('p', {
    staticClass: "recmnb",
    attrs: {
      "id": "recmn5"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_47",
      "title": "47"
    }
  }, [_vm._v("MAY")])]), _vm._v(" "), _c('figure', {
    staticClass: "img70b",
    attrs: {
      "id": "page46"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_46",
      "title": "46"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0046-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p47"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0047-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page47"
    }
  }, [_vm._v("VEGETABLE SOUP WITH PEARL BARLEY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("After a long journey through Japan, I returned home with a craving for vegetables. I had never eaten as well as I did over there, but finding a hearty bowl of fresh veggies took some effort in the land of the rising sun. Back home, my vegetable garden had started growing without me and the shelves in the produce store were brimming with delicate Dutch spring greens. I went to my local park to forage some more, and while I was basking in the warm sun, my oven was baking a nourishing soup that brought tears of joy to my eyes. Actually, this is a recipe sans recipe. I use pearl barley as a base, because it’s so nutritious and retains its bite for a long time. Feel free to use whatever you like—farro, orzo, brown rice, or whole wheat grains; pasta is tasty too. But be sure to adjust the cooking time if you do. To prevent having to turn on the oven only for a pot of soup, I made something else with the rest of the vegetables (see the next recipe).")]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("makes 1 pot of soup")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("6½ cups (1½ L) vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 cup (200 g) pearl barley (preferably presoaked)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Lots of fast-cooking vegetables, such as:")]), _vm._v(" "), _c('p', {
    staticClass: "ingrennb"
  }, [_vm._v("Generous 1¼ pounds (600 g) unshelled fresh podded peas, or 1¼ cups (200 g) shelled ones")]), _vm._v(" "), _c('p', {
    staticClass: "ingrennb"
  }, [_vm._v("1 heaping cup (125 g) haricots verts or green beans, cut into short pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ingrennb"
  }, [_vm._v("¾ cup (100 g) green asparagus tips")]), _vm._v(" "), _c('p', {
    staticClass: "ingrennb"
  }, [_vm._v("4 scallions, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Handful of (wild) spinach")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Handful of foraged or garden herbs like wild garlic, parsley, fennel fronds, chives, sprouts, horseradish leaves, bitter cress, French sorrel, edible flowers, basil, and so on")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("⅔ cup (100 g) crumbled feta cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Splash of delicious oil, such as pumpkin seed oil or a peppery olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Pour the stock into a heavy pan, add the barley, cover, and place in the oven. Set your timer for 35 minutes and go play outside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Taste whether the barley is almost done or needs a couple more minutes. Presoaked barley could be tender by now, unsoaked barley takes longer; almost 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Now add all of the vegetables, except for the herbs. Generously grind black pepper on top.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place the pan back into the oven for 8 to 10 more minutes, until everything is al dente. Stir in the herbs and spoon into large bowls. Sprinkle with some feta and a splash of oil.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page48"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48",
      "title": "48"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0048-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p49"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0049-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page49"
    }
  }, [_vm._v("THE GREENEST CRUSTLESS PIE")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49",
      "title": "49"
    }
  }, [_vm._v("Ricotta is a wonderful ingredient. It fits really well in these times of trying to throw out as little as possible and reuse everything. The literal meaning of the word "), _c('em', [_vm._v("ricotta")]), _vm._v(" is “cooked again”; it’s made from the whey that is leftover after making cheese. This can come from cow, goat, sheep, or buffalo milk cheeses. And believe me, after making cheese, producers are left with liters of this light yellow, mildly sour liquid. It’s often used as pig feed. However, whey also contains proteins that will solidify once you reheat them—and you get the crumbly by-product called ricotta. Strictly speaking, ricotta can’t be called a cheese, but “protein-rich by-product” doesn’t sound particularly appealing, does it? Whatever it may be, I stirred heaps of ricotta in with the remaining vegetables from the Vegetable Soup with Pearl Barley ("), _c('a', {
    attrs: {
      "href": "#/xhtml/veg#p47"
    }
  }, [_vm._v("this page")]), _vm._v("), so I suppose you could say this pie is itself a by-product—and a delicious one at that!")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4 for dinner, or 6 for lunch")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("10 cups (300 g) wild spinach")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 heaping cup (125 g) haricots verts or green beans, cut into short pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 cups plus 2 tablespoons (750 ml) ricotta")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 egg yolks")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1½ cups (150 g) grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 scallions, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Handful of foraged or garden herbs like wild garlic or chives, French sorrel, baby dandelion leaves, dill, basil, parsley, and so on")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Thoroughly grease a small springform pan (8½ or 9 inches/22 cm).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Blanch the spinach in a saucepan of boiling water, scoop from the pan, and then cook the green beans until al dente; rinse with cold water. Press all the remaining water from the spinach and finely chop.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In a bowl, beat the ricotta, whole eggs, egg yolks, Parmesan, and lots of pepper until smooth. With a spoon, fold in all of the vegetables, including the scallions, and herbs and pour the mixture into the springform pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Bake for about 1 hour (depending on the size and depth of your pie). Check now and then; if it feels firm and the middle has become nicely dry, the pie is done.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Let cool slightly and serve with a salad.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page50"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_50",
      "title": "50"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0050-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p51"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0051-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page51"
    }
  }, [_vm._v("OVEN ASPARAGUS WITH CASHEW CREAM")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_51",
      "title": "51"
    }
  }, [_vm._v("I’ve been under the spell of cashews for a while now. In vegan cooking, they are often used as a cream substitute. Without realizing it you’ll be eating a nut-based cream sauce that can compete with any crème fraîche–based version. What’s more, the cashews only enhance the scrumptiousness; that mild, nutty flavor is a welcome companion to the asparagus and it really complements this dish—tempting us to lick our plates. In the "), _c('em', [_vm._v("New York Times")]), _vm._v(", I saw an amazing method for cooking your asparagus: place them upright in the oven. They maintain more of their flavor and bite that way. Here’s my version, which is not quite completely vegan, by the way. If that is important to you, replace the anchovies with sea salt to taste.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4 as part of a dinner, or 6 for lunch")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 pounds 3 ounces (1 kg) asparagus, peeled, bottoms trimmed")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1½ cups (175 g) raw, unsalted cashews, soaked in water for 1 hour")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Juice and grated zest of 1 lemon")]), _vm._v(" "), _c('p', {
    staticClass: "ingresb"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOR THE PANGRATATTO")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 dry slices white bread")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 tablespoons raw cashews, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 anchovy fillets, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Pinch of chile flakes, to taste")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Trim one-quarter from the bottom of the asparagus spears and keep for later use. Place the bundle of asparagus upright on a double sheet of aluminum foil on a baking sheet and wrap the foil around it, propping your spears so they remain standing. Sprinkle with oil, salt, and pepper. Wrap in more foil so the spears are fully covered and bake, standing up, for 25 to 35 minutes (depending on thickness), until al dente.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Process the nuts along with 2 cups plus 2 tablespoons (500 ml) water and the asparagus ends to a smooth sauce in a blender. Transfer to a saucepan and bring to a boil. Let simmer for 10 minutes and season with lemon juice/zest, salt, and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Make the pangratatto: Grind or chop the bread and nuts into a crumb. In a skillet, heat the oil, add the anchovies, and let dissolve. Add the bread-nut crumb and the chile flakes. Cook while stirring until golden brown and crispy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the cooking liquid from the asparagus into the cashew sauce. Serve the asparagus on a preheated dish, drizzled with cashew cream and sprinkled with the pangratatto.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page52"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_52",
      "title": "52"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0052-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p53"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0053-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page53"
    }
  }, [_vm._v("VEGGIE FILO PIE")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_53",
      "title": "53"
    }
  }, [_vm._v("I spent some time in Ireland. The Irish are fine cooks, especially now that they’re beginning to discover the many wonderful ingredients their country produces. But because we were working in a tiny mountain village (often with our dog in tow) and most days we wouldn’t sit down for dinner until late, we had to resort to pub grub, invariably from the same establishment. Often bar food implies a lack of vegetables. Or boring ones. In England, I’ve been in the same situation—to the extent that after fourteen days I was so starved for greens that I decided to prepare them myself on a Primus stove next to my car. It’s said that the average Dutch person doesn’t meet the recommended dose of 7 ounces (200 grams) per day (it’s only 7 ounces, people!), but the British in rural villages sometimes don’t even reach a quarter of that. Anyway, I’m home now and I’ll be eating only vegetables for the coming weeks, starting with this dish.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Splash of olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 leeks, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 cloves garlic, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("10½ ounces (300 g) spinach")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 (14-ounce/400 g) can chickpeas, rinsed and drained")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 egg")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 generous cup (250 ml) ricotta, drained")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ teaspoon freshly grated nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ teaspoon smoked paprika")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Chile flakes")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("⅔ cup (100 g) crumbled feta cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("4 to 5 sheets filo dough")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Heat some oil in a wide saucepan and sauté the leeks and garlic for 6 minutes, or until tender. Add the spinach and cook for 5 minutes while stirring. Drain the vegetables in a sieve and use a spoon to press out all liquid. Spoon in the chickpeas.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Beat the egg with the ricotta and season with nutmeg, paprika, salt, and chile flakes. Crumble the feta over the mixture and combine with the vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Grease an 8-inch (20 cm) springform pan. Line with the sheets of filo dough. Rotate each sheet 90 degrees and let them hang over the edges of the pan. Fill with the ricotta mixture and fold over the hanging dough sheets, making the pie look rustic.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bake for almost 1 hour, or until the pie is golden brown and done. Serve warm, or cold with a salad.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page54"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_54",
      "title": "54"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0054-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p55"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0055-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page55"
    }
  }, [_vm._v("TARTE AUX LÉGUMES")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_55",
      "title": "55"
    }
  }, [_vm._v("Done. The vacation is planned and booked. Each year I’m always surprised and realize I should’ve done all of this by last November because all the cute summer homes are rented. Oh, well. Our first stop will be in Provence, a tradition for us, where my friend Valerie will be awaiting our arrival for afternoon drinks (the "), _c('em', [_vm._v("apéro")]), _vm._v(") with a table filled with rosé, beer, "), _c('em', [_vm._v("vin de noix")]), _vm._v(", pastis, pitchers of water, and buckets of ice cubes. As per tradition she will also serve a home-baked tomato tart. I make the same tart, but use multiple vegetables instead. Tomatoes are often juicy, which isn’t conducive to a crunchy crust. The result is gorgeous, as long as you arrange the razor-thin vegetable slices, alternating between the three types, inside the crust’s frame with Zen-like dedication. Vacation on a baking sheet: "), _c('em', [_vm._v("Santé")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 (10½-ounce/300 g) package puff pastry, rolled out into a rectangle")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 egg, beaten")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1½ zucchinis")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 orange sweet pointed peppers, or 1 large orange or yellow bell pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("5 to 6 tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Splash of olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 teaspoons fresh thyme leaves")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("6 tablespoons (35 g) grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Place the dough sheet on a parchment paper–lined baking sheet. Using the back of a knife, carve a border about 1 inch (2.5 cm) wide along the edges, creating a frame. Brush with beaten egg. Using a fork, poke holes into the crust inside the frame. Prebake for 12 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Meanwhile, slice all of the vegetables, using a sharp knife or a mandolin slicer, as thinly as you dare.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Remove the prebaked crust from the oven. If necessary, flatten any air bubbles with the back of a spoon. Fill the crust inside the frame by shingling the various vegetables: slice of zucchini, ring of sweet pepper, tomato, zucchini, and so on. The more meticulous, the nicer the result.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sprinkle with salt and pepper, a splash of oil, the thyme, and cheese. Bake the tart for 30 minutes. Serve warm or cold.")]), _vm._v(" "), _c('p', {
    staticClass: "recmnb",
    attrs: {
      "id": "recmn6"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_57",
      "title": "57"
    }
  }, [_vm._v("JUNE")])]), _vm._v(" "), _c('figure', {
    staticClass: "img70b",
    attrs: {
      "id": "page56"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_56",
      "title": "56"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0056-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p57"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0057-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page57"
    }
  }, [_vm._v("RHUBARB BEET SALAD")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("After St. John’s Day on June 24 (or after June 21, the longest day of the year), white asparagus and rhubarb are no longer harvested. Our seasons are related to the position of the Earth relative to the sun, and after June 21 the Northern Hemisphere is turning farther away from the sun—the so-called summer solstice (our winter solstice is on December 21). This shift has an effect on nature. After the summer solstice, many plants develop flowers and young sprouts, or they grow out.")]), _vm._v(" "), _c('p', {
    staticClass: "indentn"
  }, [_vm._v("Therefore, rhubarb and asparagus plants are no longer harvested, allowing them to grow new sprouts to store energy for the coming year undisturbed. Another reason is that closer to June 21, rhubarb leaves produce more oxalic acid, which negatively affects their flavor. So the third week of June is typically the last opportunity to buy rhubarb and white asparagus. Make the most of it. You’ll have to wait a long time until the next harvest.")]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 pound 10 ounces (750 g) red beets")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("10½ ounces (300 g) rhubarb, cut into 1-inch (2.5 cm) pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 tablespoons (50 g) sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Large bunch fresh flat-leaf parsley (1 ounce/30 g), coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("¼ cup (10 g) tarragon or dill, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("5¼ ounces (150 g) baby spinach")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 cup (150 g) crumbled feta cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 tablespoons (60 ml) olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Splash of fresh lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Place all of the beets in a baking dish, cover with aluminum foil, and bake for 40 to 50 minutes, until tender. Combine the rhubarb with the sugar and place them in the baking dish with the beets for the final 12 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Let the beets cool somewhat, then rub off the skins. Break into pieces. Drain the rhubarb over a bowl, saving the liquid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In a large serving bowl, gently combine the rhubarb with the beets, parsley, tarragon, spinach, and cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whisk together a dressing from the rhubarb juice and the oil, seasoning with lemon juice, salt, and pepper. Sprinkle onto the salad and serve.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page58"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_58",
      "title": "58"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0058-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p59"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0059-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page59"
    }
  }, [_vm._v("FOCACCIA WITH CRUSHED TOMATOES")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_59",
      "title": "59"
    }
  }, [_vm._v("Regular all-purpose flour has an average extraction rate and ash content (in France it’s called type 55), making it especially useful for common baked goods that require some level of leavening such as pancakes, pound cakes and bread, or cookies. For "), _c('em', [_vm._v("truly")]), _vm._v(" good bread you want a higher extraction rate (type 65), which has better leavening properties. This type of flour is often used in bread mixes, and you can buy it at a specialty store or directly from a mill. All-purpose flour (type 45) is a finer version of wheat flour and it contains more gluten, making it even more suited for baking cakes and pastries. Italians use a different scale. Their tipo 00 compares to the French type 40, a very fine hard wheat flour that is used for things that hardly need to rise, if at all, such as pasta. For making pizza or focaccia, there’s farina pizza tipo 00—a flour mixture. When making focaccia I add some extra hard semolina flour to help the leavening and provide that necessary gluten. By substituting white wine for water you emulate the hint of sourness that makes sourdough bread so lovely.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4 to 6 as a snack or side dish")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2½ teaspoons (8 g) instant yeast")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("About 1 cup plus 2 tablespoons (275 ml) lukewarm white wine, plus a dash extra")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 cups plus 2 tablespoons (400 g) farina pizza tipo 00 or all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ cup plus 1 tablespoon (100 g) semolina")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 teaspoon (5 g) sea salt, plus extra for the sauce")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 tablespoons plus 1 teaspoon (50 ml) olive oil, plus extra")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 pound 2 ounces (500 g) mini plum tomatoes or cherry tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 cloves garlic, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Leaves from a few sprigs fresh oregano")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Mix the yeast with a splash of wine and let stand for 5 minutes. Combine the flours and the salt. Form an indentation in the middle and while stirring, pour in the dissolved yeast, the remaining wine, and the oil. Continue to knead well. Focaccia dough should be nice and smooth but not too sticky. Add more flour or wine if needed. Cover and let rise for 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 425°F (220°C); if you want you can place a pizza stone in the oven.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Heat some oil in a saucepan. Crush the tomatoes with your hands and cook them. Add the garlic, oregano, and salt and pepper and reduce to a thick sauce. Let cool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Press out the dough and roll out into a rectangle. Using your fingertips, press dimples into the dough. Spread the sauce over the dough and generously sprinkle with a half-wine, half-water mixture. Bake for about 20 minutes, until golden.")]), _vm._v(" "), _c('p', {
    staticClass: "recmnb",
    attrs: {
      "id": "recmn9"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_61",
      "title": "61"
    }
  }, [_vm._v("SEPTEMBER")])]), _vm._v(" "), _c('figure', {
    staticClass: "img70b",
    attrs: {
      "id": "page60"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_60",
      "title": "60"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0060-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p61"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0061-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page61"
    }
  }, [_vm._v("ZUCCHINI WITH RICOTTA & LEMON")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("The French name for zucchini, "), _c('em', [_vm._v("courgette")]), _vm._v(", comes from the word "), _c('em', [_vm._v("courge")]), _vm._v(", meaning “squash.” So "), _c('em', [_vm._v("courgette")]), _vm._v(" is a diminutive and it refers to summer squash, which we eat unpeeled, rind and all. It’s a smaller variety of the squashes and pumpkins we harvest in the fall. And just like there are many types of squash, there also are many types of "), _c('em', [_vm._v("courgette")]), _vm._v(". At my neighborhood store I increasingly spot yellow ones. These taste different from the green ones; yellow squash are more pronounced. And because their pulp is a little firmer, they maintain their shape better when baked or grilled than their more watery—but nonetheless tasty—green cousins. I grow green and striped zucchini in my garden. If you grow your own zucchini you have the luxury of deciding exactly when you want to harvest them; small ones, raw and thinly sliced, are really delicious in a salad. The really large ones are great for making soup, but the medium-sized ones—I harvest them when they’re still slightly smaller than those sold at the average store—are great for baking. The following recipe, for instance, is a wonderfully fresh late-summer dish.")]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 zucchini")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Scant 1½ cups (350 ml) ricotta")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Grated zest of 1 lemon")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 teaspoon chile flakes, or to taste")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Small handful of garden herbs, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Panko or homemade breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Halve the zucchini lengthwise and scoop out the seeds with a spoon. Place on a parchment paper–lined baking sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In a bowl, combine the ricotta, lemon zest, chile flakes, and herbs and fill the hollow zucchini with this mixture. Sprinkle with salt and pepper and breadcrumbs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bake the zucchini halves for 35 minutes, until tender through and through. Serve as a side dish with chicken or fish or as a vegetarian main course along with some other vegetables or a salad.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page62"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_62",
      "title": "62"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0062-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p63"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0063-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page63"
    }
  }, [_vm._v("BALSAMIC BEETS WITH A CELERIAC CREAM")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_63",
      "title": "63"
    }
  }, [_vm._v("Beets. I can’t get enough of them. I sowed them in my vegetable garden. Not too many, just for fun. Two rows of yellow ones because they are so deliciously sweet. Two rows of Chioggia, the red-and-white-striped ones, because they’re so beautiful. And just a short row of red beets, because the supermarket has those too. Mine didn’t grow as big as the specimens I buy, but wow, what flavor! Those tiny sweet beets, straight from my planters, turned out to be the tastiest ingredient my garden produced this year. Next year I’ll sow three times as many.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4 as a side dish, or 2 as a main course")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 to 5 beets, peeled and quartered")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 red onions, peeled and quartered")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 tablespoons balsamic vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ tablespoon honey")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 tablespoon fresh thyme leaves")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("1 tablespoon finely chopped fresh tarragon")]), _vm._v(" "), _c('p', {
    staticClass: "ingresb"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOR THE CELERIAC CREAM")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 cloves garlic, pressed")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 tablespoon olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 celery root, peeled and cut into ½-inch (12 mm) cubes")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1⅔ cups (400 ml) milk")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Spread the quartered beets and onion on a baking sheet. Sprinkle with 2 tablespoons of the oil and a pinch of salt and pepper. Slide into the middle of the oven and bake until al dente, about 35 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In a bowl, stir the vinegar and honey together and add the remaining 1 tablespoon oil. Add three-quarters of the herbs and a pinch of salt and pepper. Douse the tray of beets and onions with the balsamic vinaigrette.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Make the celeriac cream: Briefly fry the garlic in the olive oil. Add the celeriac and stir. Douse with the milk and a glass of water if necessary to cover. Add salt and pepper to taste. Cover with a lid and simmer for 20 minutes, or until the celeriac is tender. Pulse everything in a blender to a smooth puree and season with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spoon into four bowls. Scoop the beets and onions on top. Sprinkle with the remaining herbs and serve.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page64"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_64",
      "title": "64"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0064-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p65"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0065-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page65"
    }
  }, [_vm._v("CHEESE ONION PIE")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_65",
      "title": "65"
    }
  }, [_vm._v("Did you know that the Netherlands is the world’s largest exporter of onions? Many of these head to Africa, where onions are very popular. However, in recent years African onion production has soared, lowering the demand for the Dutch onion. As a result, the Netherlands is now sitting on a giant surplus. We made a television episode about it, and guess what? After filming, I was left with an onion surplus of my own. That very night I made this English onion pie with it. Onion is delicious, versatile, and cheap. Why not eat it more often?")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingresb"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOR THE FILLING")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 tablespoon plus 2 teaspoons (25 g) butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("6 onions, cut into thin rings")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4⅓ cups (500 g) shredded cheddar or another aged cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 bunch fresh chives, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("4 scallions, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingresb"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOR THE DOUGH")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("10½ tablespoons (150 g) butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 cups plus 2 tablespoons (400 g) all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("1 egg, beaten")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Start the filling: Melt the butter in a heavy pan and fry the onions until translucent and soft, about 10 minutes. Douse with about 7 tablespoons (100 ml) water. Cook to reduce until most of the water has evaporated and season with salt and pepper. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Make the dough: In a pan, melt the butter for the dough together with a scant ½ cup (110 ml) water. Combine the flour and salt and pour in the warm butter mixture. Stir to make a cohesive dough.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 350°F (180°C). Grease a springform pan (about 9½ inches/24 cm).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Roll out two-thirds of the dough into a large round that more than covers the bottom of the baking pan. Don’t worry if the slab tears, you can easily press the pieces back together.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Combine the cheese with the chives and scallions. Spread half of the fried onions over the dough bottom, then add half of the cheese. Repeat: spread the remaining half of the onions on top of that, and sprinkle the remaining cheese on top. Roll out the rest of the dough and place on top. Using a fork, seal the edges and poke some holes to allow the steam to escape.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bake for 45 minutes, or until nicely golden brown. Let the pie cool a little before cutting it.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page66"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_66",
      "title": "66"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0066-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p67"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0067-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page67"
    }
  }, [_vm._v("BAKED BEETSTEAK")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_67",
      "title": "67"
    }
  }, [_vm._v("We’ve been eating a lot less meat at home, just like a lot of people around me. I’ve noticed that many of them have their doubts about “meat substitutes,” though. The thing is, there really is no need to fill a gap between the vegetables and potatoes on your plate. You simply prepare a dish that happens to not contain meat—that’s something else altogether. Of course, you can fry an egg or make something out of vegan meat (I still wonder what that might be), but don’t worry that I’m about to try to sell you on some sort of bland tofu burger. No way, I won’t do it. There’s so much more inspiration to be found from honest vegetables. Beetsteak, for instance: a lovely little dish, super easy. More so than actual steak, which is easy to ruin. Not beetsteak. Success every time. Serve your beetsteaks on a chunky tabouleh with lots of chickpeas. Pretty tasty.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("6 beets")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 tablespoons grapefruit juice or orange juice")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 tablespoon red wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 tablespoons (60 ml) olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 tablespoons minced fresh mint leaves")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 tablespoons minced fresh chives")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("6 tablespoons (60 ml) plain Greek yogurt")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Wrap all of the beets in aluminum foil. Place them in a baking dish and bake for 40 to 50 minutes, or until tender.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Let cool somewhat and rub off the skins. Use your palm to gently push down on the beets. Not so hard that you crush them but just enough to flatten them a bit.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In a wide bowl, whisk together the grapefruit juice, vinegar, 2 tablespoons of the oil, salt and pepper to taste, and half of the herbs. Roll the beets through this mixture. Let stand for 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In a skillet, heat the remaining 2 tablespoons oil over medium heat. Fry the beets for 5 minutes on each side, or until they start to brown.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stir the remaining marinade into the yogurt, spoon over the fried beetsteaks, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "recmnb",
    attrs: {
      "id": "recmn10"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_69",
      "title": "69"
    }
  }, [_vm._v("OCTOBER")])]), _vm._v(" "), _c('figure', {
    staticClass: "img70b",
    attrs: {
      "id": "page68"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_68",
      "title": "68"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0068-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p69"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0069-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page69"
    }
  }, [_vm._v("TWICE-BAKED SWEET POTATOES")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("Whenever I mention sweet potatoes, the husband immediately pulls a long face. He finds them mushy and bland, kind of like baby food. I can see his point. When low-carb recipes call for sweet potato oven fries I always feel duped; not only do they not taste like potato, they really never turn out crispy. That’s because sweet potatoes aren’t potatoes. They’re a root vegetable originally from South America. But because they grow underground and look like potatoes, they nearly share the same name. It would be better to rename them completely. Change those expectations, because although the "), _c('em', [_vm._v("batata")]), _vm._v("—or yam—is no traditional Dutch vegetable like the potato, it is in fact delicious. Season this dish generously. Who’s talking about baby food now?")]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 6 as a side dish, or 3 as a main course (along with a salad, for instance)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 sweet potatoes of equal size, washed")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("7 ounces (200 g) spinach")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Juice and grated zest of ½ lemon")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 teaspoon paprika")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Pinch of ground cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("¾ cup (75 g) grated aged Cheddar cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Generous ½ cup (125 ml) sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Handful of chopped fresh cilantro")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Place the sweet potatoes on a parchment paper–lined baking sheet and bake for about 1 hour. Depending on their size they should be nicely baked by then. If you can easily stick in a knife, they’re done.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Halve the sweet potatoes and use a spoon to hollow out the middle part, leaving just a thin shell. Set the potato flesh aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Cook the spinach in some oil. Douse with lemon juice, then drain and press out as much liquid as possible. Finely chop.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Combine the chopped spinach with the sweet potato flesh and season with lemon zest, paprika, cayenne, and salt and pepper. Stuff the hollowed-out skins with the mixture and put back on the baking sheet. Sprinkle with the cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Return them to the oven for another 10 minutes or so to make sure they’re nicely hot and the cheese has melted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve with some sour cream and cilantro on top.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page70"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_70",
      "title": "70"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0070-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p71"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0071-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page71"
    }
  }, [_vm._v("STUFFED AUTUMN PORTOBELLOS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_71",
      "title": "71"
    }
  }, [_vm._v("My Italian friend Maria is an amazing cook, better than anyone. At least that’s the myth she created around herself, and I’m willing to believe her. Maria’s parents had an olive grove in Calabria. While folding laundry together Maria tells me stories of how her mother used to make fresh mozzarella and then ricotta from the leftover whey. How the fireplace was always burning so that they could steam beans and that the next morning the glowing embers were used to bake the day’s bread. How her family preserved their own summer vegetables for the winter. She goes back often. For instance, when her sister has a pig slaughtered the entire family lends a hand to process the whole animal. Whenever she returns from one of her trips back home she brings me something. Sometimes it’s a fragrant orange from her brother’s garden, and recently she gave me four Calabrese peppers. They came with a warning: besides being the most delicious peppers ever, they are also dangerously hot. I used a piece of the first chile pepper in the following—faintly Italian—side dish, especially for Maria.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 portobello mushrooms, stems removed")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 cups (200 g) finely chopped cavalo nero (Tuscan kale)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 cloves garlic, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 eggs, beaten")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 tablespoons crème fraîche")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ cup (50 g) grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 tablespoons chopped roasted hazelnuts")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Pinch of minced red (Calabrian) pepper (or to taste)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Heat a grill pan on the stove. Place the mushroom caps, gills facing up, on top. Leave for about 20 minutes, or until small drops begin to form between the gills. Transfer to a plate and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 350°F (180°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fry the kale in some oil with the garlic until wilted, then transfer to a bowl and stir in the eggs, crème fraîche, cheese, and hazelnuts, and add as much finely chopped Calabrian peppers as you like (and some salt). Generously fill the mushrooms with the mixture. Place on a baking sheet and bake until just done, about 20 minutes. Serve.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page72"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_72",
      "title": "72"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0072-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p73"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0073-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page73"
    }
  }, [_vm._v("ROASTED TOMATILLO SALSA")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_73",
      "title": "73"
    }
  }, [_vm._v("Recently we were shooting for our TV show in the Dutch province of Drenthe. It was there, in the wonderful vegetable gardens of farmer André, that I suddenly spotted them: towering plants brimming with tomatillos. How nice! I’d never seen these exotic fruits on a plant before, and here they were, in the Netherlands, of all places. The tomatillo is a fruit that somewhat resembles the Cape gooseberry (they’re both called Physalis) and the green tomato. They originally come from Mexico and were important ingredients of the Mayan and Aztec cuisines. They’re not always easy to find, but because homemade tomatillo salsa goes so well with tortilla chips or a grilled hen, I happily bike the extra mile to buy them. As should you: this recipe is so incredibly easy that you’d be crazy not to make it. André’s tomatillos are sold at the Amsterdam farmers market, but you can also find them at Mexican grocery and produce stores. They’re beautiful. And delicious.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("makes 1 jar")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("About 20 small tomatillos (1 pound 10 ounces/750 g)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 jalapeño (or more), stemmed")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 cloves garlic, unpeeled")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 to 3 scallions, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 bunch fresh cilantro (about ¾ ounce/20 g)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Juice of 2 limes")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Pinch of sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the broiler to high heat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Husk the tomatillos and clean the sticky skin by washing them in a large pot of water. Spread out on a parchment paper–lined baking sheet. Add the jalapeño and garlic cloves and broil everything for 14 minutes, or until black marks begin to form. Turn the vegetables over halfway through the baking time.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meanwhile, process the remaining ingredients to a pulp in a blender. Squeeze the garlic cloves out of their skins and add them to the blender, together with the other contents of the baking sheet, and blend into a thick green sauce. Store the salsa in a clean jar in the fridge, where it will keep for 1 week.")]), _vm._v(" "), _c('p', {
    staticClass: "recmnb",
    attrs: {
      "id": "recmn11"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_75",
      "title": "75"
    }
  }, [_vm._v("NOVEMBER")])]), _vm._v(" "), _c('figure', {
    staticClass: "img70b",
    attrs: {
      "id": "page74"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_74",
      "title": "74"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0074-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p75"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0075-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page75"
    }
  }, [_vm._v("RED CABBAGE WITH PARMESAN & GARLIC")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("Red cabbage is also known as purple cabbage. The red-purple color of the leaves is caused by the plant’s pigments, which turn either more red, or purple, depending on the pH level of the soil. So the location of a cabbage plant determines its color. In order to retain the nice red tint while cooking them, you can add a splash of acid; my mother used ketchup (for the sweet-sour effect), but a splash of vinegar (and some sugar) works as well. Otherwise the cabbage will turn blue when cooked. I, on the other hand, simply toss the cabbage wedges into the oven. They retain their beautiful deep purple hue while becoming crispy on the outside and staying juicy within. Such an autumn treat. You can serve them with delicious mashed celeriac or mashed sweet potato and cavolo nero with roasted garlic.")]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 tablespoons (55 g) butter, melted")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 cloves garlic, very finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Generous ¾ cup (75 g) grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 tablespoons panko or homemade breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ red cabbage, cut into 6 wedges, with the stem on")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Maldon sea salt flakes and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("A few drops of good balsamic vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Brush a baking sheet with some melted butter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In a bowl, combine the rest of the butter with the garlic, cheese, and breadcrumbs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Place the cabbage wedges, spaced a little apart, on the baking sheet. Divide the butter and cheese mixture among the cabbage wedges and spread evenly. Season with salt flakes and pepper if desired.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Bake the wedges for 30 minutes, or until the tops are crispy and it’s easy to stick a knife into them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sprinkle with some vinegar and serve.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page76"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_76",
      "title": "76"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0076-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p77"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0077-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page77"
    }
  }, [_vm._v("KOHLRABI WITH A SPICY CREAM OF POINTED RED PEPPER")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_77",
      "title": "77"
    }
  }, [_vm._v("Kohlrabi is one of those vegetables that is easily overlooked. Not to be confused with rutabaga, kohlrabi (or German turnip) looks like a root vegetable sticking its arms up in the air. They’re mostly light green but can also be purple. They’re really delicious. Peeled and raw in a salad, they taste a little like radish, but you can also quarter them and throw them in a stew. Sliced or cut into chunks, they can be fried. And, of course, you can bake them whole in the oven. Because anything you can do with a beet, you can do with a kohlrabi. The kohlrabi is also the only one out of the common family of tubers that grows aboveground. That’s because this tuber is in fact a pantry, where the plant stores its nutrients, making kohlrabi exceptionally healthy to boot. I love it. This recipe is a lovely little vegetarian main course, delicious with a tabouleh of grains and lots of fresh herbs on the side.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 kohlrabi")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Splash of olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 cup (150 g) crumbled feta cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 roasted sweet pointed red peppers, peeled and seeded")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("½ to 1 tablespoon pickled jalapeño rings")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Some sprigs of fresh flat-leaf parsley, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Pinch of chile flakes (or to taste)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Clean the kohlrabi, remove the stems, and brush with some oil. Place on a baking sheet and sprinkle with salt and pepper. Bake for 1½ to 2 hours (depending on their size), until charred on the outside and tender within.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Let cool slightly, then peel. If you'd like, you can slice the kohlrabi before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In a food processor, puree the feta, sweet peppers, jalapeño, and parsley. Spread the red cream onto a large platter. Place the peeled kohlrabi on top. Drizzle with some oil and sprinkle with a pinch of salt and chile flakes if you like, then serve.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page78"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_78",
      "title": "78"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0078-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p79"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0079-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page79"
    }
  }, [_vm._v("GRILLED EGGPLANT WITH BURRATA")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_79",
      "title": "79"
    }
  }, [_vm._v("Recently I visited the region of Apulia, in the heel of the Italian boot. In nearly every restaurant they served an antipasto of a halved grilled eggplant, with or without a topping. Each time it was cooked to perfection: Not too long, which causes the eggplant to lose its form and makes it more suitable for a baba ghanoush dip; but not too short, either, which would render it hard and bland. No, without exception these eggplants were meaty, with a profound grilled flavor. This is what I love so much; doing just one thing really well and then serving the result as is. Try to follow that approach with this recipe!")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4 as an appetizer")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 eggplant")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Generous splash of peppery olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2 large cloves garlic, thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 ball super-fresh burrata (8¾ ounces/250 g)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Chile flakes and flaky salt (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 435°F (225°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Halve the eggplants lengthwise. Carve several deep slits along the sides, as well as the top. Make sure not to cut them all the way through. Lightly sprinkle with salt and pepper. Brush the cut sides and top with oil. Stud the slits with garlic slices.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Place the eggplant halves on a baking sheet in the oven, cut sides up. Bake for 45 minutes, or until they’re tender but not quite beginning to fall apart. The top should be nicely browned. Brush with some oil halfway through the cooking time.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("After baking, let rest for 10 minutes. Cut the burrata in half. Divide the creamy fresh cheese over the eggplant halves. Drizzle with some really good olive oil. Sprinkle with (chile!) pepper and salt flakes, if you’d like. Serve right away.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Delicious, right? Holy moly. Heavenly.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page80"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_80",
      "title": "80"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0080-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p81"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0081-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page81"
    }
  }, [_vm._v("MUSHROOM FLAMMKUCHEN")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_81",
      "title": "81"
    }
  }, [_vm._v("The traditional thin-crust pizza from the French Alsace region isn’t topped with tomato sauce but with crème fraîche (as well as bacon and onion). While the French call this pizza variety "), _c('em', [_vm._v("tarte flambée,")]), _vm._v(" just across the border in Germany it’s known as "), _c('em', [_vm._v("flammkuchen")]), _vm._v(". The Italians have their own tomato-free pizza. They replace the crème fraîche with mascarpone, and then top it according to regional taste and call it "), _c('em', [_vm._v("pizza bianca")]), _vm._v(" (white pizza). I like to eat my "), _c('em', [_vm._v("flammkuchen")]), _vm._v(" topped with a "), _c('em', [_vm._v("Bergkäse")]), _vm._v(" like Gruyère or Taleggio and some meaty oyster mushrooms. To each his own, I guess.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("makes 2 pizzas")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("⅔ cup to ¾ cup (175 to 200 ml) lukewarm water")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1½ teaspoons instant yeast")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("2⅓ cups (300 g) all-purpose flour, plus extra for dusting")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Pinch of sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("2 tablespoons butter, melted")]), _vm._v(" "), _c('p', {
    staticClass: "ingresb"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOR THE TOPPING")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 pound 2 ounces (500 g) oyster mushrooms, shredded")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 clove garlic, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Fresh thyme")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3 scallions, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Sea salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("10 tablespoons (150 ml) crème fraîche")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("7 ounces (200 g) Taleggio cheese (or Gruyere, raclette or mozzarella), cubed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Mix half of the water with the yeast. Let stand for 7 minutes. Combine the flour and the salt in a bowl. Pour in the yeast mixture and add the butter. While stirring, add the rest of the water in splashes until the dough begins to come together. Continue kneading for another 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In a covered and greased bowl, let the dough rise for 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Make the topping: Heat a skillet with some oil and fry the mushrooms, garlic, and thyme, stirring until tender. Add three-quarters of the scallions. Season with salt and pepper. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 425°F (225°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Briefly knead the dough some more and divide into two portions. On a lightly floured work surface, roll out one portion of dough as thinly as possible. Transfer the thin dough slab to a sheet of parchment paper on a baking sheet and spread with crème fraîche. Spread half of the mushroom mixture and half of the cheese on top.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Bake for 12 to 15 minutes, until golden brown. Sprinkle with half of the remaining scallions and serve while you make the second one.")]), _vm._v(" "), _c('p', {
    staticClass: "recmnb",
    attrs: {
      "id": "recmn12"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_83",
      "title": "83"
    }
  }, [_vm._v("DECEMBER")])]), _vm._v(" "), _c('figure', {
    staticClass: "img70b",
    attrs: {
      "id": "page82"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_82",
      "title": "82"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0082-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p83"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0083-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page83"
    }
  }, [_vm._v("ONION WITH CREAM, SAGE & STILTON")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("Oh, the lowly onion. What a modest role it plays in our kitchen. You often forget how divine it is even though so many recipes begin with an onion. Sautéed in butter or oil, they smell like heaven, and only then does the dish really take off. But there’s no reason why the onion shouldn’t be playing the lead role. This recipe will change the way you look at it. My neighborhood supermarket carries many varieties of onions. The following recipe offers you the opportunity to experiment. I’d urge you to be creative. Try it. We ate this dish in combination with a roasted chicken and a green salad. It was onion-believable.")]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4 as a side dish")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("1 saucepan full of broth (vegetable, beef, or chicken; enough to submerge everything)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("4 large onions")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("¾ cup plus 1 tablespoon (200 ml) heavy cream")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("6 fresh sage leaves")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("3½ ounces (100 g) Stilton cheese (or another aged cheese such as Parmesan or Cheddar)")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Bring a saucepan of broth to a boil. Peel the onions but leave them whole and add to the broth. Again bring to a boil and reduce the heat to medium, allowing the onions to cook slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Cook them for 45 minutes to 1 hour, until soft. You should feel no resistance when poking them with a sharp knife. The cooking time depends on the size of the onions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Meanwhile, preheat the oven to 400°F (200°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Scoop the onions from the pan, then halve and place them cut side down in a baking dish. Drizzle with the cream, press sage leaves in between, and crumble the cheese on top. Sprinkle with pepper and bake for 25 minutes, or until golden brown.")]), _vm._v(" "), _c('figure', {
    staticClass: "img90b",
    attrs: {
      "id": "page84"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_84",
      "title": "84"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0084-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _vm._v(" "), _c('figure', {
    staticClass: "imageb",
    attrs: {
      "id": "p85"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0085-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')]), _vm._v(" "), _c('p', {
    staticClass: "rechd",
    attrs: {
      "id": "page85"
    }
  }, [_vm._v("NOBU’S TOMATOES")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_85",
      "title": "85"
    }
  }, [_vm._v("At home, we regularly eat Japanese food. This isn’t so much thanks to me but rather to my husband, Oof Verschuren. He devours every book and movie about Japanese cuisine that comes out and he is without exaggeration one of the best Japanese chefs I know (excluding “real” ones). He doesn’t prepare standard sushi, but true homemade Japanese food: dishes whose existence I was completely unaware of and whose names I cannot pronounce. When I asked him for a Japanese oven dish for this book, he could only come up with one. The Japanese aren’t big oven chefs. They often cook over open fire, but that isn’t quite the same. Therefore, I give you this minimalist recipe inspired by Nobu Matsushisa, a celebrated Japanese chef who became famous for his Japanese-Peruvian fusion cuisine during the ’90s. Oof makes these tomatoes nearly every time he cooks for me. They really are incredible flavor bombs that will bring you tears of joy. It is one of my all-time favorite dishes.")])]), _vm._v(" "), _c('p', {
    staticClass: "serszb"
  }, [_c('em', [_vm._v("serves 4 as a side dish")])]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Handful of mini vine tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Splash of ponzu")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb"
  }, [_vm._v("Splash of olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingreb1"
  }, [_vm._v("Pinch of roasted sesame seeds (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Preheat the oven to 210°F (100ºC).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Bring a large pot of water to a boil. Using a pointed knife, carve a small x on the bottom of each little tomato, but do make sure to leave the stems on. Carefully let the tomatoes slide into the boiling water, then scoop them out with a slotted spoon after a few seconds. Now you can easily peel off the skin. Leave the stems on.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place them on a parchment paper–lined baking sheet and dry them in the warm oven for 4 hours. Oof serves them straight after they’ve cooled off with a drop of ponzu and oil and sometimes a sprinkle of roasted sesame seeds. Nobu lets them dry uncovered in the fridge for another 6 hours. It’s a versatile dish that works with everything, from fish and meat to cheese.")]), _vm._v(" "), _c('figure', {
    staticClass: "img70b",
    attrs: {
      "id": "fig47"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_86",
      "title": "86"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0086-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figcap"
  }, [_vm._v("VEGETABLE SOUP WITH PEARL BARLEY, "), _c('a', {
    attrs: {
      "href": "#/xhtml/veg#page47"
    }
  }, [_vm._v("THIS PAGE")])])])])]), _vm._v(" "), _c('figure', {
    staticClass: "img70b",
    attrs: {
      "id": "fig55"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_87",
      "title": "87"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0087-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figcap"
  }, [_vm._v("TARTE AUX LÉGUMES, "), _c('a', {
    attrs: {
      "href": "#/xhtml/veg#page55"
    }
  }, [_vm._v("THIS PAGE")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08e6cd2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/veg.vue
// module id = 75
// module chunks = 0